import { render, staticRenderFns } from "./VolunteerJobsList.vue?vue&type=template&id=29b8602f&scoped=true&"
import script from "./VolunteerJobsList.vue?vue&type=script&lang=js&"
export * from "./VolunteerJobsList.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerJobsList.vue?vue&type=style&index=0&id=29b8602f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b8602f",
  null
  
)

export default component.exports